import React from "react";
import Templates from "../../pages/roblox/Templates";
import ShowTemplate from "../../pages/roblox/Templates/Show";
import Content from "../../pages/roblox/Content";
import Community from "../../pages/roblox/Community";
import ShowSkins from "../../pages/roblox/Skins/Show";
import Users from "../../pages/roblox/Users";
import ShowUser from "../../pages/roblox/Users/Show";
import Assets from "../../pages/roblox/Assets";
import Reports from "../../pages/roblox/Reports";

const robloxRoutes = [
  { path: '/roblox/content',            element: <Content /> },
  { path: '/roblox/content/pants',      element: <Content collection='pants' /> },
  { path: '/roblox/content/shirts',     element: <Content collection='shirts' /> },
  { path: '/roblox/content/t_shirts',   element: <Content collection='t_shirts' /> },
  { path: '/roblox/content/posts',      element: <Content collection='posts' /> },

  { path: '/roblox/community',          element: <Community /> },
  { path: '/roblox/community/pants',    element: <Community collection='pants' /> },
  { path: '/roblox/community/shirts',   element: <Community collection='shirts' /> },
  { path: '/roblox/community/t_shirts', element: <Community collection='t_shirts' /> },
  { path: '/roblox/community/posts',    element: <Community collection='posts' /> },

  { path: '/roblox/templates',          element: <Templates /> },
  { path: '/roblox/templates/pants',    element: <Templates collection='pants' /> },
  { path: '/roblox/templates/shirts',   element: <Templates collection='shirts' /> },
  { path: '/roblox/templates/t_shirts', element: <Templates collection='t_shirts' /> },
  { path: '/roblox/templates/:id',      element: <ShowTemplate /> },

  { path: '/roblox/assets',             element: <Assets /> },
  { path: '/roblox/assets/patterns',    element: <Assets target='patterns' /> },
  { path: '/roblox/assets/accessories', element: <Assets target='accessories' /> },

  { path: '/roblox/skins/:id',          element: <ShowSkins /> },

  { path: '/roblox/users',     element: <Users /> },
  { path: '/roblox/users/:id', element: <ShowUser /> },

  { path: '/roblox/reports', element: <Reports /> },
]

export default robloxRoutes;
